import React from 'react';
import { useNavigate } from 'react-router-dom';
import leftArrowNoBg from './left-arrow.svg';

const SuccessHeader = () => {

    const navigate = useNavigate();

    return(
        <div className='success-header-bg'>
            <img src={leftArrowNoBg} alt="" className='diet-plan-left-arrow-specific' onClick={() => navigate(-1)} />
        </div>
    );
}

export default SuccessHeader;
